<template>
    <b-row>
        <b-col md="12">
            <gofix-card class="mb-0" fullContent>
                <gofix-default-table class="hoverUnderLineLink" :settings="tableConfig" :table-items="tableItems" @load-items="getTableData" @row-click="goToDetail" ref="gofixTable">
                    <template slot="gofix_table:before-control-right" slot-scope="row">
                        <gofix-button v-if="show_btn_link_case" @click="openModalLinkCase" label="Link Case" outline></gofix-button>
                    </template>   
                    <template slot="gofix_table:reference_number" slot-scope="row">
                        <span class="link">{{row.item.reference_number}}</span>
                    </template>
                    <template slot="gofix_table:issue_date" slot-scope="row">
                        {{row.item.issue_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                    </template>
                </gofix-default-table>
            </gofix-card>
            <b-modal :no-close-on-backdrop="true"
                 size="xl" id="modal-lineItem"
                 modal-class="modal-link-case"
                 :title="modals.caseItem.title"
                 hide-footer :centered="true"
                 v-model="modals.caseItem.open">
                <b-form class="formV2" v-bind:class="{'run-loading':modals.caseItem.loading}">
                    <b-row class="content align-items-center">
                        <b-col md="12">
                            <gofix-form-dropdown
                                    class="fakeTable"
                                    label="Item"
                                    vLabel="case_number"
                                    :filterable="false"
                                    v-model="modals.caseItem.model"
                                    @search="searchCase"
                                    @change="selectCaseItem"
                                    :options="modals.caseItem.data">

                                <template #gofixInput:dropdown:list-header>
                                    <div class="d-table fakeTableHeader">
                                        <div class="d-table-cell cell itemTitle itemCode">Case No</div>
                                        <div class="d-table-cell cell itemTitle itemSorGroup">Requestor</div>
                                        <div class="d-table-cell cell itemTitle itemDescription">Location</div>
                                    </div>
                                </template>
                                <template #gofixInput:dropdown:option="{ case_number , address_display_name, address_email, address_secondary_phone, location_root_path}">
                                    <div class="d-table fakeTableBody">
                                        <div class="d-table-cell cell itemValue itemCode">{{case_number}}</div>
                                        <div class="d-table-cell cell itemValue itemSorGroup">
                                            {{address_display_name}}<br/>
                                            {{address_email}}<br/>
                                            {{address_secondary_phone}}
                                        </div>
                                        <div class="d-table-cell cell itemValue itemDescription">{{location_root_path}}</div>
                                    </div>
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button :loading="modals.caseItem.loading" @click="linkCaseSubmit" label="SUBMIT" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-col>
    </b-row>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
export default {
    name: 'work_folder',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['work_folder']));
        return {
            tableConfig: {
                name: 'case-management-work-folder',
                controls: {
                    tableImport: false,
                    create: false,
                    delete: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "asc",
            },
            tableItems: [],
            modals:{
                caseItem:{
                    open:false,
                    loading:false,
                    title:'Link Case',
                    data:[],
                    model:[],
                    timer:null
                }
            },
            caseLists:[],
            show_btn_link_case:false,
            notInIds:[]
        }
    },
    watch: {
        "CaseItem": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    computed: {
        ...mapGetters({
            CaseItem: "CaseManagementController/Item"
        })
    },
    created() {
        if(this.CaseItem && 
            this.CaseItem.status != 'Closed' && 
            this.CaseItem.contract &&
            this.CaseItem.contract.case_settings &&
            this.CaseItem.contract.case_settings.is_use_nlt_case_module){
            this.show_btn_link_case = true;
        }
    },
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if (!this.CaseItem.folder_id) {
                this.tableItems = [];
                this.tableConfig.total = 0;
                resolve({
                    items: [],
                    total: 0
                });
            }
            tableRequest.filter.folder_id.value = this.CaseItem.folder_id;
            await this.$store.dispatch("WorkFolderController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load items", "danger");
                    reject();
                });
        },
        goToDetail(item) {
            let routeData = null;
            switch (item.reference_value_text) {
                case "Work order":
                    routeData = this.$router.resolve(`/v2/orders/${item.work_item_id}`);
                    break;
                case "AP Invoice":
                    routeData = this.$router.resolve(`/v2/ap-invoice/${item.work_item_id}`);
                    break;
                case "Payment voucher":
                    routeData = this.$router.resolve(`/v2/payment-voucher/${item.work_item_id}`);
                    break;
                case "Misc Expense":
                    routeData = this.$router.resolve(`/v2/misc-expenses/${item.work_item_id}`);
                    break;
                default:
                    routeData = this.$router.resolve(`/v2/case/${item.work_item_id}`);
                    break;
            }
            if (routeData) {
                window.open(routeData.href, '_blank');
            }
        },
        /*----------------------------------------*/
        selectCaseItem(item){
            //
        },
        searchCase(search, loading){
            loading(true);
            if(this.modals.caseItem.timer) {
                clearTimeout(this.modals.caseItem.timer);
            }
            //
            let tableRequest = {
                filter: {
                    client_contract_id:{
                        function: "=",
                        type: "number",
                        value: this.CaseItem && this.CaseItem.client_contract_id,
                        with: []
                    },
                    status: {
                        function: "=",
                        type: "collection",
                        value: "Closed",
                        with: []
                    },
                    case_number:{
                        function: "ilike",
                        type: "text",
                        value: search,
                        with: []
                    },
                },
                isCMS: 1,
                limit: 50,
                page: 1,
                sortColumn: "id",
                sortDirection: "DESC",
                useDatabaseView: false,
                notInIds:true
            };
            this.modals.caseItem.timer =  setTimeout(() => {
                this.$store.dispatch( 'CaseManagementController/getList',tableRequest)
                    .then(response => {
                        this.modals.caseItem.timer = false;
                        this.modals.caseItem.data = response.data.data.items;
                        loading(false)
                    })
                    .catch(err => {
                        console.log(err)
                        this.modals.caseItem.timer = false;
                        loading(false)
                    })
            },300)
        },
        async getCaseList(){
            let tableRequest = {
                filter: {
                    client_contract_id:{
                        function: "=",
                        type: "number",
                        value: this.CaseItem && this.CaseItem.client_contract_id,
                        with: []
                    },
                    status: {
                        function: "=",
                        type: "collection",
                        value: "Closed",
                        with: []
                    }
                },
                isCMS: 1,
                limit: 50,
                page: 1,
                sortColumn: "id",
                sortDirection: "DESC",
                useDatabaseView: false,
                notInIds:true,
            };
            await this.$store.dispatch("CaseManagementController/getList", tableRequest)
                .then(response => {
                    this.modals.caseItem.data = response.data.data.items;
                    resolve(response.data.data);
                })
                .catch(err => {
                    //this.$alertNotification("Can not load the case management", "danger");
                    //reject();
                })
        },
        async openModalLinkCase(){
            this.modals.caseItem.open = true;
            await this.getCaseList();
        },
        linkCaseSubmit(){
            if(!this.modals.caseItem.model || !this.modals.caseItem.model.id){
                return this.$alertNotification('Please choose case','danger');
            }
            let request = {
                case_current_id: parseInt(this.$route.params.id),
                case_link_id: this.modals.caseItem.model && this.modals.caseItem.model.id
            };
            this.modals.caseItem.loading = true;
            this.$store.dispatch("CaseManagementController/linkCaseSubmit", request)
            .then(response => {
                this.modals.caseItem.loading = false;
                this.modals.caseItem.open = false;
                this.$alertNotification('Link case successully!','success');
                this.$refs.gofixTable.reloadTableItems();
            })
            .catch(err => {
                this.modals.caseItem.loading = false;
            });
        }
    }
}
</script>